import React from "react";
import PropTypes from "prop-types";
import cn from "../../../utils/cn";
import filterChildren from "../../../utils/Children/filterChildren";
import "./Table.scss";
import { jsx as _jsx } from "react/jsx-runtime";
const TableBody = _ref => {
  let {
    id = "",
    className = "",
    onCellClick = null,
    style = {},
    children = [],
    secondaryDataList = []
  } = _ref;
  const tableBodyClass = cn("align-middle border-collapse w-full overflow-hidden", className);
  const filteredChildren = filterChildren(children);
  const childrenWithFuncs = React.Children.map(filteredChildren, (child, index) => /*#__PURE__*/React.cloneElement(child, {
    ...(onCellClick ? {
      onCellClick: onCellClick
    } : null),
    parent: "table-body",
    rowIndex: index,
    secondaryDataList
  }));
  return /*#__PURE__*/_jsx("tbody", {
    id: id,
    className: tableBodyClass,
    style: style,
    children: childrenWithFuncs
  });
};
TableBody.propTypes = {
  /** id for reference */
  id: PropTypes.string,
  /** className for reference */
  className: PropTypes.string,
  /** prop function when user clicks */
  onCellClick: PropTypes.func,
  /** Override the inline-styles of the root element || Not Recommended */
  style: PropTypes.object,
  /**
   * children props for content inside
   * @ignore
   */
  children: PropTypes.node,
  /**
   * Data (in columns) to hide passed from TableRow component
   * @ignore
   */
  secondaryDataList: PropTypes.array
};
export default TableBody;
//# sourceMappingURL=TableBody.js.map